import React from 'react';
import SingleCare from '../../../images/singlecare.png';
import cvs from '../../../images/wallmart-cvs.png';
import wmcvs from '../../../images/wallmart-cvs.png';
import cvsdot from '../../../images/cvs-dot.png';
import ld from '../../../images/longs-drugs.png';
import './card-styles.css';

export function CVSCardFront({ bin, pcn, groupNumber, memberId }) {
    return (
        <div className="w-full max-w-[500px] min-h-[300px] rounded-2xl overflow-hidden bg-[#313131] flex flex-col justify-between relative">
            {/* Side Icon */}
            <div className="absolute left-0 top-0 w-20 h-20 sm:w-[50px] sm:h-[50px] card-side-icon" />

            {/* Card Header */}
            <div className="pt-5 px-3.5">
                <div className="flex justify-between items-center text-sm font-medium text-white pl-[50px] font-urbanist">
                    <img src={SingleCare} className="max-w-full h-auto" alt="SingleCare Logo" />
                    <div className="text-sm font-medium">For exclusive use at <img src={cvs} alt="CVS Logo" className="inline ml-1" /></div>
                </div>
                <div className="bg-[#1e76d0] text-white uppercase text-center font-bold text-sm py-1.5 px-1.5 mt-2 font-urbanist">
                    Pharmacy Savings Card
                </div>
            </div>

            {/* Card Body */}
            <div className="py-2.5 px-6">
                <div className="font-semibold text-xl w-full text-white text-center mb-2 font-urbanist">
                    Save up to 80% on your prescriptions.
                </div>
                <div className="flex justify-between items-end flex-wrap">
                    <div className="w-auto">
                        <div className="text-white text-[22px] sm:text-xs font-urbanist">
                            Member ID <span className="block">{memberId}</span>
                        </div>
                    </div>
                    <div className="text-white font-normal text-[28px] leading-[1.3] sm:text-lg font-urbanist">
                        <div>Bin: <span>{bin}</span></div>
                        <div>Group: <span>{groupNumber}</span></div>
                        <div>PCN: <span>{pcn}</span></div>
                    </div>
                </div>
            </div>

            {/* Card Footer */}
            <div className="bg-[#f19f57] px-3.5 py-2 text-sm text-[#313131] font-normal flex justify-between items-end font-urbanist">
                <div className="w-[190px] max-w-[50%]">
                    Show this card to save up to 80% on your prescriptions
                </div>
                <div className="w-[270px] max-w-full">
                    <div className="font-bold mb-2 sm:mb-1.5">
                        This card is free. This is not insurance.
                    </div>
                    <p className="text-[#313131] text-sm">
                        Customer Service: 1-800-999-3053
                    </p>
                </div>
            </div>
        </div>
    );
}

export function CVSCardBack() {
    return (
        <div className="w-full max-w-[500px] min-h-[300px] rounded-2xl overflow-hidden bg-[#313131] flex flex-col justify-between">
            {/* Card Body */}
            <div className="flex flex-wrap p-3 sm:p-2 pt-2.5 text-center leading-none">
                <h3 className="text-[#ce0c2e] text-sm px-7.5 pb-1 w-full mb-1.5 text-white font-urbanist">
                    Exclusive savings at CVS Pharmacy&#174; locations<br />on prescription medications.
                </h3>
                <div className="w-full text-[11px] text-white font-urbanist">
                    <p className="mb-1.5 sm:mb-0.5"><strong>Customer Instructions:</strong> Show this card to your CVS pharmacist to receive savings. For more information, call toll-free to 1-866-978-1084.</p>
                    <p className="mb-1.5 sm:mb-0.5"><strong>Pharmacist Instructions:</strong> This card entitles the cardholder to all prescription benefits associated with the BIN, GRP, and PCN codes. For help processing, please call toll-free at 1-800-974-3135.</p>
                </div>
                <h4 className="text-xs block w-full text-white mb-1.5 mt-1 font-urbanist">
                    This card is accepted at <img src={wmcvs} alt="Walmart CVS" className="inline max-w-[60px] max-h-[8px] mx-1" /> <img src={cvsdot} alt="CVS Pharmacy" className="inline max-w-[60px] max-h-[8px] mx-1" /> <img src={ld} alt="Longs Drugs" className="inline max-w-[60px] max-h-[8px] mx-1" />
                </h4>
                <p className="text-[11px] w-[90%] mx-auto text-white font-urbanist">
                    Visit <a href="https://singlecare.com/honestdiscounts" target="_blank" rel="noopener noreferrer" className="text-[#ce0c2e]">singlecare.com/honestdiscounts</a> for more information, pricing and participating pharmacies.
                </p>
                <p className="text-[11px] w-[90%] mx-auto mb-2 text-white font-urbanist">
                    Your privacy is protected. We do not rent or sell your personal information.<br />By using this card you have agreed to the terms and conditions found at singlecare.com/terms-and-conditions. The CVS Pharmacy logo is a trademark and/or registered trademark of CVS Pharmacy and/or one of its affiliates.
                </p>
                <div className="separator-line text-[11px] text-white mb-2 sm:mb-1 font-urbanist">
                    <span>This card is free. This is not insurance</span>
                </div>
            </div>

            {/* Card Footer */}
            <div className="text-[11px] sm:text-[10px] bg-[#3b3d40] p-1.5 sm:p-2 font-urbanist">
                <div className="w-full flex text-white justify-between mb-1">
                    <span className="inline-block w-1/2 text-left">&copy; 2019 SingleCare Administrators</span>
                    <span className="inline-block w-1/2 text-right">SCHD_0819_CVS_CA</span>
                </div>
                <div className="text-white">
                    <h4 className="text-sm font-semibold font-urbanist">Pharmacist Instructions</h4> 
                    <p className="text-[11px] font-urbanist">This card is preactivated and gives member discounts through the BIN. PCN, GROUP on the front If you need assistance, call 811-800-7820</p>
                </div>
            </div>
        </div>
    );
}
